import type { ViewportToolsetId } from "@/viewport-tools/core/contracts";
import { VIEWPORT_TOOLSET_PLUGINS } from "@/viewport-tools/plugins";
import type { ViewportToolsetRailPlugin } from "./types";

export const VIEWPORT_TOOLSET_RAIL_PLUGINS: ViewportToolsetRailPlugin[] =
  VIEWPORT_TOOLSET_PLUGINS.map((plugin) => plugin.rail);

const VIEWPORT_TOOLSET_RAIL_PLUGIN_BY_ID: Partial<
  Record<ViewportToolsetId, ViewportToolsetRailPlugin>
> = VIEWPORT_TOOLSET_RAIL_PLUGINS.reduce(
  (acc, plugin) => {
    acc[plugin.id] = plugin;
    return acc;
  },
  {} as Partial<Record<ViewportToolsetId, ViewportToolsetRailPlugin>>
);

export function getViewportToolsetRailPlugin(toolsetId: ViewportToolsetId) {
  return VIEWPORT_TOOLSET_RAIL_PLUGIN_BY_ID[toolsetId];
}
